// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35Obb","content":"styles_content__3E-pB","tableWrap":"styles_tableWrap__3JH3q"};